import React from 'react'

import classes from './Loading.module.scss'
import LoadingDots from '../loading-dots'

export const Loading = () => (
  <p className={classes.loadingWrapper}>
    Loading <LoadingDots />
  </p>
)

export default Loading
